import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchAvailableRooms } from '../../features/admin/roomSlice';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import RoomFilter from './RoomFilter';
import RoomCard from './RoomCard';

import { CiFilter } from 'react-icons/ci'
import { Room } from '../../types';
import Loading from '../ui/Loading';
import { useSEO } from '../../custom hooks/useSEO';
import { useNavigate } from 'react-router-dom';
import { clearSavedRooms } from '../../features/home/bookingSlice';
const RoomsAvailable = () => {
    const { t } = useTranslation();
    const { t: tSeo } = useTranslation("seo");

    const seo = useSEO({
        title: tSeo("placeRooms.title"),
        description: tSeo("placeRooms.description")
    });
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [openFilter, setOpenFilter] = useState(false);
    const { place } = useSelector((state: RootState) => state.placeSlice);

    const { availableRooms, loading } = useSelector((state: RootState) => state.roomSlice);
    const { roomIds } = useSelector((state: RootState) => state.bookingSlice);
    const userId = Cookies.get('userId');
    const [filters, setFilters] = useState({
        minPrice: 0,
        maxPrice: 0,
        type: "",
        services: [] as number[],
    })
    useEffect(() => {
        const checkInStr = sessionStorage.getItem('checkIn');
        const checkOutStr = sessionStorage.getItem('checkOut');

        const checkIn = checkInStr ? new Date(checkInStr) : null;
        const checkOut = checkOutStr ? new Date(checkOutStr) : null;
        dispatch(clearSavedRooms())
        dispatch(fetchAvailableRooms({
            stayId: place?.id,
            userId: userId,
            checkIn: checkIn?.toISOString(),
            checkOut: checkOut?.toISOString()
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const middleRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        middleRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);
    const filteredRooms = useMemo(() => {
        return availableRooms.filter(room => {
            const matchPrice =
                (filters.minPrice === 0 || room.pricePerNight >= filters.minPrice) &&
                (filters.maxPrice === 0 || room.pricePerNight <= filters.maxPrice);

            const matchType =
                !filters.type || room.type.toLowerCase() === filters.type.toLowerCase();

            const matchServices =
                filters.services.length === 0 ||
                filters.services.every(serviceId =>
                    room.amenities.some(a => a.id === serviceId)
                );

            return matchPrice && matchType && matchServices;
        });
    }, [availableRooms, filters]);
    if (loading) return <Loading />
    return (
        <div className='main-prop  padding-container' ref={middleRef}>
            {seo}
            <button onClick={() => setOpenFilter(!openFilter)} className=' xs:flex md:hidden mb-3 w-full bg-white rounded-lg border border-grayColor px-4 py-1 flex-center gap-1'>
                <span>{t("filter-title")} </span>
                <CiFilter className=' text-secondry text-lg' />
            </button>
            <div className=' grid relative gap-5 xs:grid-cols-1 md:grid-cols-4'>
                <div className={`${openFilter ? "" : "xs:hidden md:col-span-1"} md:col-span-1 md:block`}>
                    <RoomFilter openFilter={openFilter} setOpenFilter={setOpenFilter} filters={filters} setFilters={setFilters} />
                </div>
                <div className=' col-span-3'>
                    {availableRooms.length === 0 ?
                        <div className=' w-full h-full flex-center flex-col text-center'>
                            <img src="/asset/empty.png" alt="" />
                            <p>{t("no-data")}</p>
                        </div>
                        :
                        <div className='space-y-4'>
                            {roomIds.length > 0 && (
                                <div className="fixed bottom-5 left-5 z-50">
                                    <button
                                        onClick={() => navigate(`/place/${place?.id}/check-out`)}
                                        className="
                                                bg-primary text-white px-6 py-3 rounded-full
                                                shadow-lg flex items-center gap-2
                                                hover:bg-primary transition-all
                                            "
                                    >
                                        {t('continue')}
                                        <span className="bg-white text-primary px-2 py-0.5 rounded-full text-sm font-bold">
                                            {roomIds.length}
                                        </span>
                                    </button>
                                </div>
                            )}


                            {filteredRooms.map((room: Room, index) => (
                                <div key={index}>
                                    <RoomCard room={room} />
                                </div>

                            ))}
                        </div>

                    }
                </div>
            </div>
        </div>
    )
}

export default RoomsAvailable